export const TRANSLATIONS_EN = {
    "home.intro": `
    <p>Ayesa makes this <strong>ETHICAL CHANNEL</strong> available to its employees and third parties in order to be able to communicate in a secure and totally confidential manner any type of query or irregularity committed in it, or in its spheres of action, about an event that could give rise to non-compliance with the principles contained in the <a href="#">Code of Ethics</a> and other internal regulations to which Ayesa is subject.</p>
    <p>The reception and management of the communications received through this channel will be the responsibility of the Compliance Body. Ayesa undertakes not to adopt any type of retaliation against those who, in good faith, inform the company of an alleged irregularity or non-compliance.</p>
    <p>For a better understanding of the management of queries and the communication of violations received through this channel, you have at your disposal the <a href="#">Policy for communication of violations</a>, where it is regulated its operation.</p>
    `,

    "home.btnNewCase": "Report a violation or make a query",

    "home.btnQuery": "Check the status of an infringement communication or a query",

    "home.btnDownload": "Download the Code of Ethics in PDF format",
  
    "thankyou.label": "Thank you",
  
    "details.label": "is an internationalization-framework which offers a complete solution to localize your product from web to mobile and desktop:is an internationalization-framework which offers a complete solution to localize your product from web to mobile and desktop",
  
    "Advantages.label": "Advantages",
  
    "Advantagesdetails.label": "Flexibility to use other packages: Flexibility to use other packages"
  
  };